import {
    GET_CONFIG_FORM36,
    POST_CONFIRMAR_RECOBRO,
    GET_ANTECEDENTES_RECOBRO
} from '../types';


export default function confirmarIngresoRecobroReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM36:
            return { ...state, cfg_form36:action.payload }
        case POST_CONFIRMAR_RECOBRO:
            return { ...state, respuestaConfirmar:action.payload }
        case GET_ANTECEDENTES_RECOBRO:
            return { ...state, antecedentesRecobro:action.payload }
       
        default:
            return state
    }
}